// Generated using ConditionsConstructor
const plantar_fascitis_heel_spur = {
  name: "Plantar Fasciitis, Heel Spur",
  meta: {
    links: [
      { label: "Plantar Fascitis", url: "https://www.myorthopedicproblem.com/services/plantar-fasciitis" },
    ],
  },
  conditions: {
    "age": "36-50,51-65,66-80,81 or older",
    "big_toe_flexibility": "yes",
    "cause": "acute_injury,arthritis_tendonitis",
    "grinding": "no",
    "instability": "none",
    "lesser_toe_flexibility": "yes",
    "numbness": "none",
    "pain_description": "chronic,intermittent",
    "pain_location": "bottom_of_heel",
    "rom": "normal",
    "swelling": "moderate",
    "weightbearing": "yes"
  },
}

const bunions_hallux_bunion = {
  name: "Bunions Hallux",
  meta: {
    links: [
      { label: "Bunion & Bunionette", url: "https://www.myorthopedicproblem.com/services/bunion-bunionette" }
    ]
  },
  conditions: {
    "big_toe_flexibility": "limited,no",
    "cause": "acute_injury,arthritis_tendonitis",
    "instability": "none,mild",
    "lesser_toe_flexibility": "yes",
    "numbness": "none",
    "pain_description": "chronic",
    "pain_location": "toes",
    "rom": "limited",
    "swelling": "moderate"
  }
}

const hammer_toe_claw_toe = {
  name: "Hammer Toe, Claw Toe",
  meta: {
    links: [
      { label: "Hammer Toe", url: "https://www.myorthopedicproblem.com/services/hammer-toe" }
    ]
  },
  conditions: {
    "age": "35 or younger,36-50,51-65",
    "big_toe_flexibility": "yes,limited",
    "cause": "acute_injury,arthritis_tendonitis",
    "grinding": "no",
    "instability": "none",
    "lesser_toe_flexibility": "yes",
    "numbness": "none",
    "pain_description": "chronic",
    "pain_location": "toes",
    "swelling": "moderate",
    "weightbearing": "limited"
  }
}

const ankle_sprain = {
  name: "Ankle Sprain",
  meta: {
    links: [
      { label: "Ankle Sprain", url: "https://www.myorthopedicproblem.com/services/ankle-sprain" }
    ]
  },
  conditions: {
    "age": "35 or younger,36-50",
    "big_toe_flexibility": "yes",
    "cause": "sports_injury,acute_injury,arthritis_tendonitis",
    "grinding": "no",
    "instability": "moderate,severe",
    "lesser_toe_flexibility": "no",
    "numbness": "none",
    "pain_description": "acute",
    "pain_location": "ankle",
    "rom": "painful_or_unable",
    "swelling": "severe",
    "weightbearing": "yes"
  }
}

const ingrown_toenail = {
  name: "Ingrown Toenail",
  meta: {
    links: [
      { label: "Ingrown Toenail", url: "https://www.myorthopedicproblem.com/services/ingrown-toenail" }
    ]
  },
  conditions: {
    "big_toe_flexibility": "yes",
    "grinding": "no",
    "instability": "none",
    "lesser_toe_flexibility": "no",
    "numbness": "none",
    "pain_description": "acute",
    "pain_location": "toes",
    "swelling": "severe",
    "weightbearing": "limited"
  }
}

const haglunds_deformity = {
  name: "Haglunds Deformity",
  meta: {
    links: [
      { label: "Haglunds Deformity", url: "https://www.myorthopedicproblem.com/services/haglunds-deformity" }
    ]
  },
  conditions: {
    "age": "35 or younger,36-50",
    "big_toe_flexibility": "yes",
    "cause": "sports_injury,acute_injury,arthritis_tendonitis",
    "grinding": "no",
    "instability": "mild",
    "lesser_toe_flexibility": "no",
    "numbness": "none",
    "pain_description": "acute",
    "pain_location": "back_of_heel",
    "rom": "limited",
    "swelling": "moderate",
    "weightbearing": "limited"
  }
}

const fractured_foot_or_ankle = {
  name: "Fractured Foot or Ankle",
  meta: {
    links: [
      { label: "Ankle Fracture", url: "https://www.myorthopedicproblem.com/services/ankle-fracture" }
    ]
  },
  conditions: {
    "big_toe_flexibility": "limited",
    "cause": "sports_injury,acute_injury",
    "grinding": "yes,intermittent",
    "instability": "severe",
    "lesser_toe_flexibility": "yes",
    "numbness": "none",
    "pain_description": "acute",
    "pain_location": "ankle",
    "rom": "painful_or_unable,limited",
    "swelling": "severe",
    "weightbearing": "yes"
}
}

const ankle_arthritis = {
  name: "Ankle Arthritis",
  meta: {
    links: [
      { label: "Ankle Arthritis", url: "https://www.myorthopedicproblem.com/services/ankle-arthritis" }
    ]
  },
  conditions: {
    "age": "36-50,51-65,66-80,81 or older",
    "big_toe_flexibility": "yes",
    "cause": "chronic_injury,arthritis_tendonitis",
    "grinding": "yes,intermittent",
    "instability": "moderate,severe",
    "lesser_toe_flexibility": "no",
    "numbness": "none",
    "pain_description": "chronic",
    "pain_location": "ankle",
    "rom": "painful_or_unable,limited",
    "swelling": "moderate",
    "weightbearing": "yes,limited"
  }
}

/* NO ARTICLE */
const hallux_rigidis = {
  name: "Hallux Rigidis",
  meta: {},
  conditions: {
    "age": "36-50,51-65,66-80,81 or older",
    "big_toe_flexibility": "no",
    "cause": "chronic_injury,arthritis_tendonitis",
    "grinding": "yes,intermittent",
    "instability": "mild",
    "lesser_toe_flexibility": "no",
    "numbness": "none",
    "pain_description": "chronic",
    "pain_location": "toes",
    "rom": "painful_or_unable,limited",
    "swelling": "moderate",
    "weightbearing": "limited"
  }
}

module.exports = {
  plantar_fascitis_heel_spur,
  bunions_hallux_bunion,
  hammer_toe_claw_toe,
  ankle_sprain,
  ingrown_toenail,
  haglunds_deformity,
  fractured_foot_or_ankle,
  ankle_arthritis,
  // hallux_rigidis
}